import React, { useState, useContext } from 'react';
import moment from 'moment';
import { FormHelperText } from '@material-ui/core';
import { ReactDatePicker } from '@mummssoftware/common-ui';
import { SET_RESOLVE_DATE } from '../../Context/constants';
import { CPPContext } from '../../Context/CPPContext';
import defaults from '../../../translations/en.json';

type EffDateProps = {
  patientCPP?: any;
};

export const EffDate = React.memo(({ patientCPP }: EffDateProps) => {
  const [effDate, setEffDate] = useState<Date | number | null>(null);
  const { dispatch } = useContext(CPPContext);
  // backend issue with date format
  const effectiveDate = new Date(`${patientCPP.effectivedate}T00:00:00`);

  const handleEffDateChange = (date: any) => {
    setEffDate(date);
    dispatch({
      type: SET_RESOLVE_DATE,
      payload: moment(date).toDate(),
    });
  };

  return (
    <>
      <FormHelperText id="component-helper-text">
        {defaults.resolveDate}
      </FormHelperText>
      <ReactDatePicker
        popperPosition="fixed"
        selectedDate={effDate}
        onChange={handleEffDateChange}
        maximumDate={new Date()}
        minimumDate={effectiveDate}
      />
    </>
  );
});
